<template>
  <div class="add-role">
    <div class="modal add-role-modal" style="position: absolute !important">
      <div class="modal-background" @click="closeModal"></div>
      <div class="modal-card">
        <section class="modal-card-body">
          <nav class="panel">
            <p class="panel-heading">{{ $t("profile.add-business-role") }}</p>
            <div v-if="!roleSelected">
              <a
                class="panel-block"
                v-for="r in availableRoles"
                :key="r"
                :id="r"
                @click="chooseRole(r)"
              >
                <span class="panel-icon" v-if="!r.includes('Motor')">
                  <i class="fa fa-shuttle-van" />
                </span>
                <span class="panel-icon" v-else>
                  <i class="fa fa-motorcycle" />
                </span>
                {{ r }}
              </a>
            </div>
            <div v-if="roleSelected">
              <div class="panel-block">
                <div class="control has-icons-left">
                  <span class="icon is-small is-left">
                    <i class="fas fa-phone" />
                  </span>
                  <input
                    class="input is-warning"
                    type="number"
                    v-model="referrer"
                    placeholder="Phone Number of Referring Driver"
                  />
                </div>
              </div>
              <div class="panel-block">
                <button
                  class="button is-info is-fullwidth"
                  v-ripple
                  :disabled="!roleSelected"
                  @click="submitRoleRequest()"
                >
                  {{ $t("submit-request") }}
                </button>
              </div>
            </div>
            <p class="has-text-grey" v-if="roleSelected">
              {{ $t("profile.requesting-access") }}
              <br />
              <span
                class="tag is-warning has-text-weight-semibold"
                @click="clearSelected"
              >
                {{ selectedRole }}
                <button class="delete is-small"></button>
              </span>
            </p>
          </nav>
        </section>
      </div>
      <button
        class="modal-close is-large"
        aria-label="close"
        @click="closeModal"
      ></button>
    </div>
  </div>
</template>

<script>
export default {
  name: "AddRoleModal",
  components: {},
  data() {
    return {
      availableRoles: [
        "Bangkok: Private Tuk Tuk",
        "Bangkok: Sii Lor",
        "Bangkok: Win Motorbike",
        "Chiang Mai: Tuk Tuk",
        "Chiang Mai: Songthaew",
      ],
      selectedRole: "",
      referrer: "",
    };
  },
  mounted() {},
  computed: {
    roleSelected() {
      if (this.selectedRole !== "") return true;
      return false;
    },
  },
  methods: {
    closeModal() {
      this.referrer = "";
      this.selectedRole = ""; // clear
      this.$el.querySelector(".modal").classList.remove("is-active");
    },
    chooseRole(val) {
      this.selectedRole = val;
      this.console("choose role", val);
    },
    clearSelected() {
      this.selectedRole = "";
    },
    // email request
    submitRoleRequest() {
      if (this.referrer) {
        alert(this.referrer);
        return;
      }
      var loader = this.loadingDots();
      this.$store
        .dispatch("sendEmail", {
          referrer: this.referrer,
          role: this.selectedRole,
          user_id: this.$store.state.user.id,
          mobile: this.$store.getters.phoneNumber,
          name: this.$store.getters.realName,
          type: "business role request",
          app: process.env.VUE_APP_TITLE,
        })
        .then((res) => this.console(res))
        .catch((err) => console.error(err))
        .finally(() => {
          loader.hide();
          this.successWait();
          this.closeModal(); // do this last or role name and referrer cleared
        });
    },
    successWait() {
      this.$swal({
        html: `<strong>${this.selectedRole}</strong><br><br>Role request submitted<br><br>Please wait for role confirmation`,
        showConfirmButton: true,
        type: "success",
      });
    },
  },
};
</script>

<style scoped>
.panel-block {
  font-size: 1.15em;
}
.modal-card-body {
  padding: 10px;
}
</style>